/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { useEffect, useState, ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { areCookiesEnabled } from '../../utils/cookies';
import EnableCookies from '../../components/enable-cookies';

const CookiesGuard = ({ children }: { children: ReactElement }): ReactElement => {
  const history = useHistory();
  const [cookiesEnabled, setCookiesEnabled] = useState(areCookiesEnabled());

  useEffect(() => {
    setCookiesEnabled(areCookiesEnabled());
  }, [history]);

  return cookiesEnabled ? children : <EnableCookies />;
};

export default CookiesGuard;
